import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const UPDATE_INTERNAL_BANNER_TEMPLATE_RESOURCES = 'UPDATE_INTERNAL_BANNER_TEMPLATE_RESOURCES';
export type UPDATE_INTERNAL_BANNER_TEMPLATE_RESOURCES = typeof UPDATE_INTERNAL_BANNER_TEMPLATE_RESOURCES;
export interface UpdateInternalBannerTemplateResources {
    type: UPDATE_INTERNAL_BANNER_TEMPLATE_RESOURCES;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    value: string;
}

export function updateInternalBannerTemplateResourcesAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    value: string
): UpdateInternalBannerTemplateResources {
    return {
        type: UPDATE_INTERNAL_BANNER_TEMPLATE_RESOURCES,
        bannerId,
        resourceId,
        value
    };
}
